import { Col, Row } from "react-bootstrap";
import backgroundImg from "../../../assets/images/background.png";
import { useNavigate } from "react-router-dom";
function Section1() {
  const navigate = useNavigate();
  return (
    <div className="HomeScreen-Section1">
      <Row>
        <Col sm={{ span: 4, order: 1 }} xs={{ span: 12, order: 2 }}>
          <div className="HomeScreen-Box1">
            <div className="HomeScreen-text1">Revolutionize Your</div>
            <div className="HomeScreen-text2">Gym With XEntryBook</div>
            <br />
            <div className="HomeScreen-text3" style={{ textAlign: "justify" }}>
              XEntryBook is the ultimate gym management solution designed to
              streamline every aspect of your fitness business. From user
              registration and attendance tracking to invoicing and membership
              management, XEntryBook simplifies operations with powerful
              automation. Effortlessly manage users, block or unblock
              memberships, and generate invoices—all from a single intuitive
              platform. Say goodbye to manual tasks and hello to efficiency with
              XEntryBook, the smart way to run your gym seamlessly.
            </div>
            <br />
            <div
              className="HomeScreen-btn"
              onClick={() => {
                navigate("/contactus");
                window.scrollTo(0, 0);
              }}
              style={{ cursor: "pointer" }}
            >
              Contact Us
            </div>
          </div>
        </Col>
        <Col sm={{ span: 8, order: 2 }} xs={{ span: 12, order: 1 }}>
          <div className="HomeScreen-Box2">
            <img src={backgroundImg} className="HomeScreen-img1" alt="bg1" />
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Section1;
